import classNames from "classnames";
import React, { FC } from "react";
import { CSS_CLASSES } from "./list-css-classes";
import { ListItemElement } from "./list-item-element";
import { ListProps } from "./list.types";

/**
 *
 * The `List` component enables users see the list of items.
 *
 */
export const List: FC<ListProps> = ({
  variant = "ordered",
  size = "medium",
  listItems,
  listItemRenderer,
  orderedListMarkerType = "1",
  orderedListStart = 1,
  unOrderedListDefaultIcon: defaultIcon,
  className: classNameProp,
}) => {
  const className = classNames(
    CSS_CLASSES.LIST_ROOT,
    {
      [CSS_CLASSES.LIST_DECIMAL]: variant === "ordered" && orderedListMarkerType === "1",
      [CSS_CLASSES.LIST_LOWER_ALPHA]: variant === "ordered" && orderedListMarkerType === "a",
      [CSS_CLASSES.LIST_UPPER_ALPHA]: variant === "ordered" && orderedListMarkerType === "A",
      [CSS_CLASSES.LIST_LOWER_ROMAN]: variant === "ordered" && orderedListMarkerType === "i",
      [CSS_CLASSES.LIST_UPPER_ROMAN]: variant === "ordered" && orderedListMarkerType === "I",

      [CSS_CLASSES.LIST_SMALL]: size === "small",
      [CSS_CLASSES.LIST_MEDIUM]: size === "medium",
      [CSS_CLASSES.LIST_LARGE]: size === "large",
    },
    classNameProp
  );

  const TagName = variant === "ordered" ? "ol" : "ul";

  const items = listItems.map((listItem, index) => {
    if (variant === "unordered" && defaultIcon && !listItem.icon) {
      listItem.icon = defaultIcon;
    }

    const listItemClassName = classNames(
      {
        [CSS_CLASSES.LIST_PRIMARY_COLOR]: listItem.textColor === "primary",
        [CSS_CLASSES.LIST_SECONDARY_COLOR]: listItem.textColor === "secondary",
        [CSS_CLASSES.LIST_ACCENT_COLOR]: listItem.textColor === "accent",
        [CSS_CLASSES.LIST_GRAY_COLOR]: listItem.textColor === "gray",
        [CSS_CLASSES.LIST_SUCCESS_COLOR]: listItem.textColor === "success",
        [CSS_CLASSES.LIST_WARNING_COLOR]: listItem.textColor === "warning",
        [CSS_CLASSES.LIST_ERROR_COLOR]: listItem.textColor === "error",
      },
      listItem.className
    );

    return (
      <li key={listItem.id ? listItem.id : `li-${index}`} className={listItemClassName}>
        {listItemRenderer ? (
          listItemRenderer({ item: listItem, index })
        ) : (
          <>
            <ListItemElement item={listItem} index={index} />
            {listItem.subList && (
              <div key={listItem.id ? listItem.id : `sub-list-${index}`} className={CSS_CLASSES.SUB_LIST}>
                <List {...listItem.subList}></List>
              </div>
            )}
          </>
        )}
      </li>
    );
  });

  return (
    <TagName className={className} start={orderedListStart}>
      {items}
    </TagName>
  );
};
